// extracted by mini-css-extract-plugin
export default {"card":"PunchupPersonEntry_card__zUF79","nameRow":"PunchupPersonEntry_nameRow__FuFhv punchupInputsRow"};